module.exports = __webpack_public_path__ + "img/257e31352598400b06b8dfea9ccaea67.77ff4a0c.png";